/* @flow */

export default {
  PARTS: 'PARTS',
  SALES: 'SALES',
  SERVICE: 'SERVICE',
  USED_VEHICLES_TRADE: 'USED-VEHICLES-TRADE'
};

